import React from 'react';
import { useSystemJurisdictions } from '../hooks/use-system-jurisdictions.js';
import SystemJurisdictionsPageView from './system-jurisdictions-page-view.jsx';

function SystemJurisdictionsPageContainer() {
  const state = useSystemJurisdictions();
  return <SystemJurisdictionsPageView {...state} />;
}

export default SystemJurisdictionsPageContainer;

